import { useCallback, useEffect, useState } from 'react';
import APIService from '../../../Services/APIService.js';
import { Apis } from '../../../Services/app.constants.js';
import { useSnackBar } from '../../../components/FlowBuilder/Common/SnackBar/index.tsx';

async function loadBusinessTypes() {
  return APIService.get(`${Apis.getAllSectors}`);
}

export function useBusinessTypeLookups() {
  const { showSnackBar } = useSnackBar();
  const [businessTypes, setBusinessTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBusinessTypes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await loadBusinessTypes();
      if (res?.status === 200) {
        setBusinessTypes(res?.data || []);
      } else {
        setError('Failed to load business types');
      }
    } catch {
      const message = 'Error fetching business type sub types';
      setError(message);
      showSnackBar(message, 'error');
    } finally {
      setLoading(false);
    }
  }, [showSnackBar]);

  useEffect(() => {
    fetchBusinessTypes();
  }, [fetchBusinessTypes]);

  return { businessTypes, loading, error, refetch: fetchBusinessTypes };
}
